export const domainColours = {
  ndovupay: '#D69E00',  
  bovepay: '#0049B3',    
  localhost: '#0049B3',  
};
 